import useSignUp from "@/lib/useQuery/user/useSignUp";
import InputFloating from "@/components/atoms/InputFloating";
import { zodResolver } from "@hookform/resolvers/zod";
import { SubmitHandler, useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { z } from "zod";
import { Button } from "@/components/ui/button";
import ErrorPopup from '@/components/custom/InfoPopups/ErrorPopup';
import SuccessPopup from '@/components/custom/InfoPopups/SuccessPopup';
import { Label } from "@/components/ui/label";
import { useState } from "react";
import PageWrapper from "@/components/atoms/PageWrapper";
import LoaderWithBackdrop from "@/components/custom/LoaderWithBackdrop";

const schema = z.object({
    first_name: z.string().min(1, "First Name is required"),
    last_name: z.string().min(1, "Last Name is required"),
    email: z.string().email(),
    password: z.string().min(6, "Password must be at least 6 characters long").max(30, "Password must not be longer than 30 characters"),
    confirm: z.string().min(6, "Password must be at least 6 characters long").max(30, "Password must not be longer than 30 characters"),
})
    .refine(data => data.password === data.confirm, {
        message: "Passwords do not match",
        path: ["confirm"],
    });

export default function Login() {
    const navigate = useNavigate();
    const { isPending, mutateAsync: mutateSignUp } = useSignUp();

    type schemaType = z.infer<typeof schema>;
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm<schemaType>({
        resolver: zodResolver(schema),
    })

    const onSubmit: SubmitHandler<schemaType> = async (data) => {
        try {
            const response = await mutateSignUp(data);

            if (!response.error) {
                SuccessPopup(`Confirmation Email has been sent to ${data.email}`, 5000);
                navigate('/login');
            } else {
                ErrorPopup(response.error.message, 5000);
            }
            console.log(response.error)
        } catch (err) {
            console.log(err)
            ErrorPopup("An error occurred. Please check your internet connection");
        }
    };
    const [showPassword, setShowPassword] = useState(false);
    return (
        <PageWrapper className='flex flex-col items-center flex-1 w-full max-w-full custom_bg'>
            {isPending && <LoaderWithBackdrop />}
            <div className="justify-center w-full max-w-lg px-3 py-8 rounded sm:px-8 bg-gray-50/80">
                <div className="mb-4">
                    <h1 className="font-bold text-center">Register</h1>
                </div>

                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="space-y-2">
                        <InputFloating
                            showError
                            type="text"
                            label="First Name"
                            register={register("first_name")}
                            errorMessage={errors.first_name?.message}
                        />
                        <InputFloating
                            showError
                            type="text"
                            label="Last Name"
                            register={register("last_name")}
                            errorMessage={errors.last_name?.message}
                        />
                        <InputFloating
                            showError
                            type="text"
                            label="E-mail"
                            register={register("email")}
                            errorMessage={errors.email?.message}
                        />
                        <div className="">
                            <Label>Password</Label>
                            <div className="relative">
                                <InputFloating
                                    showError
                                    type={showPassword ? "text" : "password"}
                                    register={register("password", { required: true })}
                                    errorMessage={errors.password?.message}
                                />
                                <button
                                    type="button"
                                    className="absolute justify-center transform translate-y-1/2 bottom-1/2 right-2"
                                    onClick={() => setShowPassword(!showPassword)}
                                >
                                    <i className={`text-xl bi bi-eye${showPassword ? "-slash" : ""}`}></i>
                                </button>
                            </div>
                        </div>
                        <InputFloating
                            showError
                            type={showPassword ? "text" : "password"}
                            label="Confirm Password"
                            register={register("confirm")}
                            errorMessage={errors.confirm?.message}
                        />
                    </div>

                    <div className="flex flex-wrap justify-end gap-2 mt-4">
                        <div className="w-full sm:w-auto">
                            <Button type="submit" className="w-full">Register</Button>
                        </div>
                    </div>
                </form>

                <div className="p-0 m-0" >
                    <div className="pt-3 text-center">
                        Already have an account? <br />
                        <Link to="../" className="text-decoration-none ">
                            Sign in <span className="font-medium text-blue-500">here</span>
                        </Link>
                    </div>

                </div>

            </div>
        </PageWrapper>
    );
}
